module.exports = __webpack_public_path__ + "img/sushi.3c295766.svg";